import { useState } from 'react';
import { Box, Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import InsightsIcon from '@mui/icons-material/Insights';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import useModuleAccess from '../../hooks/useModuleAccess';

export const DASHBOARDS = [
  { path: '/home', label: 'Business Dashboard', Icon: DashboardOutlinedIcon, subModule: 'business_dashboard' },
  { path: '/inventory-dashboard', label: 'Inventory Dashboard', Icon: Inventory2OutlinedIcon, subModule: 'inventory_dashboard' },
  { path: '/coa-dashboard', label: 'CoA Dashboard', Icon: InsightsIcon, subModule: 'coa_dashboard' },
];

// Switcher between the dashboards; the one currently open is shown as selected.
const DashboardsMenu = (_props: { compact?: boolean }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { can } = useModuleAccess();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const current = DASHBOARDS.find((d) => d.path === pathname);
  const CurrentIcon = current?.Icon || DashboardOutlinedIcon;

  return (
    <>
      <Button
        onClick={(e) => setAnchor(e.currentTarget)}
        startIcon={<CurrentIcon sx={{ color: '#fff !important' }} />}
        endIcon={<KeyboardArrowDownIcon sx={{ color: '#fff !important' }} />}
        sx={{
          backgroundColor: '#059669',
          color: '#fff',
          textTransform: 'none',
          fontWeight: 700,
          fontSize: { xs: '0.75rem', md: '0.82rem', lg: '0.78rem' },
          borderRadius: 999,
          border: '1px solid #059669',
          boxShadow: 'none',
          px: { xs: 1.25, md: 1.75, lg: 1.25 },
          // Same 38px box as the count pills beside it, so the row lines up.
          height: 38,
          py: 0,
          whiteSpace: 'nowrap',
          flexShrink: 0,
          minWidth: 'auto',
          '& .MuiButton-startIcon': { mr: 0.75 },
          '& .MuiButton-endIcon': { ml: 0.5 },
          '&:hover': { backgroundColor: '#047857', borderColor: '#047857', color: '#fff' }
        }}
      >
        <Box component="span">
          {current?.label || 'Dashboards'}
        </Box>
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { mt: 0.75, borderRadius: 2, minWidth: 220 } }}
      >
        {DASHBOARDS.filter((d) => can('dashboard', 'view', d.subModule)).map(({ path, label, Icon }) => (
          <MenuItem
            key={path}
            selected={path === pathname}
            onClick={() => { setAnchor(null); if (path !== pathname) navigate(path); }}
            sx={{ '&.Mui-selected': { backgroundColor: '#ecfdf5', '& .MuiListItemText-primary': { fontWeight: 700, color: '#059669' } } }}
          >
            <ListItemIcon><Icon fontSize="small" sx={{ color: '#059669' }} /></ListItemIcon>
            <ListItemText primary={label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default DashboardsMenu;
